module.exports = __webpack_public_path__ + "static/img/021_9.bdccf2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/021_9.jpg
// module id = 6D05
// module chunks = 1